import React, { Suspense } from 'react'
import './App.css'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import { AuthProvider, RequireAuth } from './auth/auth'
import { ModalProvider } from './common/modal/modalContext'
import Logout from './logout/Logout'
import packageJson from '../package.json'
global.appVersion = packageJson.version

// Lazy loading of home introduced to prevent websocket being started before redirect to authentication (bodge?)
const Home = React.lazy(() => import('./home/Home'))

// This site has 3 pages, all of which are rendered
// dynamically in the browser (not server rendered).
//
// Although the page does not ever refresh, notice how
// React Router keeps the URL up to date as you navigate
// through the site. This preserves the browser history,
// making sure things like the back button and bookmarks
// work properly.

const ProtectedRoute = ({ path }) => (
  <Route exact path={path}>
    <RequireAuth>
      <Suspense fallback={''}>
        <ModalProvider>
          <Home />
        </ModalProvider>
      </Suspense>
    </RequireAuth>
  </Route>
)

// TODO: Add spinner in home suspense fallback component
export default function App() {
  return (
    <AuthProvider>
      <Router>
        <ProtectedRoute path="/" />
        <ProtectedRoute path="/board/:boardId" />
        <ProtectedRoute path="/board/:boardId/route/:boardRouteId" />
        <Route exact path="/logout" component={Logout} />
      </Router>
    </AuthProvider>
  )
}